import { isString } from 'angular';
var iconMappings = {
    mobile_phone: 'smartphone',
    other: 'talk_time_bubble',
    smartphone_tablet: 'smartphone-tablet-ready',
};
export var DeviceTypeIconDirective = [
    function () {
        return {
            link: function ($scope, $element, $attributes) {
                var icon = $attributes.deviceTypeIcon;
                if (!isString(icon)) {
                    icon = '';
                }
                icon = icon.toLowerCase();
                var mappedIcon = iconMappings[icon] || '';
                $element.addClass("icon icon__" + (mappedIcon || icon));
            },
            restrict: 'A',
        };
    },
];
